import React from 'react';
import { useQueryClient } from 'react-query';

import { Typography } from 'antd';
import styled from 'styled-components';

import { updateShopRequest } from 'apis/ShopRequestAPI';
import { useAppSelector } from 'store/hook';

import ShopRequestUserInfo from '../ShopRequestUserInfo';
import { MysteryShopRequestInbound } from '../types';

const Container = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
`;

const LinkContainer = styled.div`
  display: flex;
  flex-flow: column;
`;

const Title = styled(Typography.Text)`
  height: 21px;
`;

const Subtitle = styled(Typography.Text)`
  color: var(--dark-blue);
  font-size: 12px;
  user-select: none;
  cursor: pointer;
`;

type Props = {
  shopRequest: MysteryShopRequestInbound;
  fieldKey: 'shopper' | 'auditor';
  fieldKeyId: 'shopper_id' | 'auditor_id';
  label?: string;
};

const ShopRequestsUserAssignment = ({ shopRequest, fieldKey, fieldKeyId, label }: Props) => {
  const queryClient = useQueryClient();
  const { currentUser } = useAppSelector((state) => state.auth);

  const assignToMe = async (event: React.MouseEvent) => {
    event.stopPropagation();
    if (!currentUser) return;

    await updateShopRequest(shopRequest.id, { [fieldKeyId]: currentUser.PAUser_Id });

    queryClient.invalidateQueries(['shopRequests']);
    queryClient.invalidateQueries(['shopRequestsGroups']);
  };

  const assignedUser = shopRequest[fieldKey];

  return (
    <Container>
      {assignedUser && (
        <ShopRequestUserInfo shopRequest={shopRequest} field={fieldKey} unassignedLabel={`Unassigned ${label}`} />
      )}
      {!assignedUser && (
        <LinkContainer>
          <Title>Unassigned</Title>
          <Subtitle onClick={assignToMe}>Assign to me</Subtitle>
        </LinkContainer>
      )}
    </Container>
  );
};

export default ShopRequestsUserAssignment;
